import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { CACHE_VARIABLES } from '../constants/cache-variables.constants';
import { STEPS } from '../constants/steps.constants';
import { CacheService } from '../services/cache.service';
// import { CacheVariables } from '../constants/cache-variables.constant';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private router: Router,
    private _cacheService: CacheService
  ) {}

  private authGuardInstance = new Subject<any>();
  authGuardIntance$ = this.authGuardInstance.asObservable();

  canActivate(
    route: ActivatedRouteSnapshot
  ): boolean | Promise<boolean> | Observable<boolean> | UrlTree {
    const authToken = this._cacheService.getItem(CACHE_VARIABLES.TOKEN);
    const tokenExpiryTime = this._cacheService.getItem(
      CACHE_VARIABLES.tokenExpiryTime
    );

    if (
      typeof authToken === 'string' &&
      authToken.length > 0 &&
      typeof tokenExpiryTime === 'number' &&
      Date.now() < tokenExpiryTime
    ) {
      let routePath = this._cacheService.getItem(
        CACHE_VARIABLES.RoutePath
      );
      if (route?.routeConfig?.path === routePath) {
        // allow navigation if via navigation service or page reload
        return true;
      } else if (this.router.url.endsWith('/')) {
        // cancel navigation if via browser address bar and navigate back to correct route or logout
        if (typeof routePath === 'string' && routePath.length > 0) {
          this.router.navigate(['/', routePath]);
        } else {
          this.router.navigate(['/login']);
        }
        return false;
      } else {
        // cancel navigation via browser back button
        return false;
      }
    } else {
      // cancel navigation if no authentication token is found or if token has expired
      this.router.navigate(['/login']);
      return false;
    }
  }
}
